import React, { Dispatch, FC, SetStateAction } from 'react';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';
import { ShowCounter } from 'src/ui/white-labels/nftsuperlab/atoms/countdown/show-counter';
import { useCountdown } from 'src/ui/white-labels/nftsuperlab/hooks/useCountdown';

interface IProps {
    targetDate: number;
    setCountDownEnd: Dispatch<SetStateAction<boolean>>;
}
export const CountdownTimer: FC<IProps> = ({ targetDate, setCountDownEnd }) => {
    const [days, hours, minutes, seconds] = useCountdown(targetDate);

    if (days + hours + minutes + seconds <= 0) {
        setCountDownEnd(true);
        return <></>;
    }

    return (
        <Spacing margin="10px 0">
            <Typography variant="title" color="text" bold uppercase>
                Countdown til launch:
            </Typography>
            <ShowCounter days={days} hours={hours} minutes={minutes} seconds={seconds} />
        </Spacing>
    );
};
